export const LOAD_PERMISSIONS = 'LOAD_PERMISSIONS'
export const LOAD_PERMISSIONS_SUCCESS = 'LOAD_PERMISSIONS_SUCCESS'
export const LOAD_PERMISSIONS_FAILURE = 'LOAD_PERMISSIONS_FAILURE'

export const UPDATE_PERMISSION = 'UPDATE_PERMISSION'
export const UPDATE_PERMISSION_SUCCESS = 'UPDATE_PERMISSION_SUCCESS'
export const UPDATE_PERMISSION_FAILURE = 'UPDATE_PERMISSION_FAILURE'